module.exports = __webpack_public_path__ + "static/media/start.530aa9d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/start.png
// module id = 1520
// module chunks = 0